// Web Audio synth engine — every sound on the site is generated in-browser.
let ctx = null;
let master = null;
let noiseBuf = null;
let humNodes = null;
let enabled = true;
const lastPlay = {};

export function setSoundEnabled(v) {
  enabled = v;
  if (!v) stopHum();
}

function ac() {
  try {
    if (!ctx) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      ctx = new AC();
      master = ctx.createGain();
      master.gain.value = 0.55;
      master.connect(ctx.destination);
      const len = Math.floor(ctx.sampleRate * 1.2);
      noiseBuf = ctx.createBuffer(1, len, ctx.sampleRate);
      const d = noiseBuf.getChannelData(0);
      for (let i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
    }
    if (ctx.state === "suspended") ctx.resume();
    return { ctx, master };
  } catch (e) {
    return null;
  }
}

function tone({ type = "sine", f0 = 440, f1 = null, dur = 0.2, peak = 0.4, delay = 0 }) {
  const A = ac();
  if (!A) return;
  const t = A.ctx.currentTime + delay;
  const o = A.ctx.createOscillator();
  o.type = type;
  o.frequency.setValueAtTime(f0, t);
  if (f1) o.frequency.exponentialRampToValueAtTime(Math.max(20, f1), t + dur);
  const g = A.ctx.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(peak, t + 0.008);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(A.master);
  o.start(t);
  o.stop(t + dur + 0.08);
}

function noise({ dur = 0.2, peak = 0.25, delay = 0, type = "highpass", f = 2000, f1 = null, q = 1 }) {
  const A = ac();
  if (!A) return;
  const t = A.ctx.currentTime + delay;
  const src = A.ctx.createBufferSource();
  src.buffer = noiseBuf;
  src.loop = true;
  const flt = A.ctx.createBiquadFilter();
  flt.type = type;
  flt.frequency.setValueAtTime(f, t);
  if (f1) flt.frequency.exponentialRampToValueAtTime(Math.max(30, f1), t + dur);
  flt.Q.value = q;
  const g = A.ctx.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(peak, t + 0.015);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  src.connect(flt).connect(g).connect(A.master);
  src.start(t, Math.random());
  src.stop(t + dur + 0.05);
}

const PLAYERS = {
  clink() {
    const d = 40 + Math.random() * 140;
    tone({ type: "sine", f0: 1900 + d, f1: 1450, dur: 0.1, peak: 0.32 });
    tone({ type: "sine", f0: 2650 + d, dur: 0.06, peak: 0.18, delay: 0.035 });
  },
  glass() {
    tone({ type: "triangle", f0: 980, f1: 620, dur: 0.3, peak: 0.28 });
    tone({ type: "sine", f0: 1560, dur: 0.16, peak: 0.13, delay: 0.02 });
  },
  clank() {
    tone({ type: "square", f0: 235, f1: 175, dur: 0.16, peak: 0.26 });
    noise({ dur: 0.09, peak: 0.22, f: 1900, type: "bandpass", q: 2 });
  },
  crinkle() {
    const n = 5 + Math.floor(Math.random() * 3);
    for (let i = 0; i < n; i++)
      noise({ dur: 0.03, peak: 0.18, delay: Math.random() * 0.3, f: 2300 + Math.random() * 2800, type: "highpass" });
  },
  squish() {
    tone({ type: "sine", f0: 330, f1: 65, dur: 0.24, peak: 0.4 });
    noise({ dur: 0.18, peak: 0.13, f: 520, type: "lowpass" });
  },
  thud() {
    tone({ type: "sine", f0: 155, f1: 68, dur: 0.18, peak: 0.5 });
  },
  thump() {
    tone({ type: "sine", f0: 110, f1: 52, dur: 0.22, peak: 0.5 });
  },
  pop() {
    tone({ type: "sine", f0: 420, f1: 920, dur: 0.09, peak: 0.38 });
  },
  rattle() {
    for (let i = 0; i < 6; i++)
      tone({ type: "sine", f0: 1500 + Math.random() * 700, dur: 0.03, peak: 0.14, delay: i * (0.045 + Math.random() * 0.03) });
    noise({ dur: 0.06, peak: 0.1, f: 2400, type: "highpass" });
  },
  rustle() {
    noise({ dur: 0.22, peak: 0.14, f: 3200, f1: 900, type: "bandpass", q: 0.7 });
    noise({ dur: 0.12, peak: 0.08, f: 2600, type: "highpass", delay: 0.05 });
  },
  plop() {
    tone({ type: "sine", f0: 260, f1: 165, dur: 0.12, peak: 0.32 });
    noise({ dur: 0.05, peak: 0.1, f: 500, type: "lowpass" });
  },
  boing() {
    tone({ type: "sine", f0: 190, f1: 58, dur: 0.34, peak: 0.38 });
    tone({ type: "sine", f0: 260, f1: 120, dur: 0.28, peak: 0.14, delay: 0.05 });
  },
  whoosh() {
    noise({ dur: 0.55, peak: 0.28, f: 420, f1: 2600, type: "bandpass", q: 0.8 });
  },
  door() {
    tone({ type: "sawtooth", f0: 96, f1: 54, dur: 0.5, peak: 0.22 });
    noise({ dur: 0.5, peak: 0.13, f: 700, f1: 2100, type: "bandpass", q: 1.2, delay: 0.04 });
    tone({ type: "sine", f0: 150, f1: 62, dur: 0.2, peak: 0.5, delay: 0.52 });
  },
  drawer() {
    noise({ dur: 0.35, peak: 0.24, f: 650, f1: 170, type: "lowpass" });
  },
  tick() {
    tone({ type: "sine", f0: 780, dur: 0.05, peak: 0.22 });
  },
  creak() {
    // groaning hinge: triangle osc with wobble, sweeping downward in pulses
    const A = ac();
    if (!A) return;
    const t = A.ctx.currentTime;
    const o = A.ctx.createOscillator();
    o.type = "triangle";
    o.frequency.setValueAtTime(215, t);
    o.frequency.exponentialRampToValueAtTime(118, t + 0.78);
    const lfo = A.ctx.createOscillator();
    lfo.frequency.value = 9 + Math.random() * 3;
    const lfoG = A.ctx.createGain();
    lfoG.gain.value = 26;
    lfo.connect(lfoG).connect(o.frequency);
    const g = A.ctx.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.linearRampToValueAtTime(0.15, t + 0.09);
    g.gain.linearRampToValueAtTime(0.045, t + 0.26);
    g.gain.linearRampToValueAtTime(0.14, t + 0.44);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.82);
    o.connect(g).connect(A.master);
    o.start(t);
    o.stop(t + 0.9);
    lfo.start(t);
    lfo.stop(t + 0.9);
    noise({ dur: 0.6, peak: 0.06, f: 900, f1: 350, type: "bandpass", q: 2.5, delay: 0.05 });
  },
  coldAir() {
    // cold air escaping: long airy swell + faint high shimmer
    noise({ dur: 1.0, peak: 0.19, f: 300, f1: 1400, type: "bandpass", q: 0.6 });
    noise({ dur: 0.8, peak: 0.07, f: 5200, f1: 2400, type: "highpass", delay: 0.15 });
  },
};

export function play(name) {
  if (!enabled) return;
  try {
    const now = performance.now();
    if (lastPlay[name] && now - lastPlay[name] < 90) return;
    lastPlay[name] = now;
    const fn = PLAYERS[name];
    if (fn) fn();
  } catch (e) {
    /* autoplay policies etc — stay silent */
  }
}

let pendingHum = false;
let gestureInstalled = false;

function installGestureOnce() {
  if (gestureInstalled || typeof window === "undefined") return;
  gestureInstalled = true;
  window.addEventListener(
    "pointerdown",
    () => {
      const A = ac();
      if (A && pendingHum && !humNodes) reallyStartHum();
    },
    { once: true }
  );
}

function reallyStartHum() {
  if (!enabled || humNodes) return;
  try {
    const A = ac();
    if (!A) return;
    const g = A.ctx.createGain();
    g.gain.value = 0;
    g.connect(A.master);
    const o1 = A.ctx.createOscillator();
    o1.type = "sine";
    o1.frequency.value = 50;
    const o2 = A.ctx.createOscillator();
    o2.type = "triangle";
    o2.frequency.value = 100;
    const n = A.ctx.createBufferSource();
    n.buffer = noiseBuf;
    n.loop = true;
    const f = A.ctx.createBiquadFilter();
    f.type = "lowpass";
    f.frequency.value = 170;
    const ng = A.ctx.createGain();
    ng.gain.value = 0.12;
    const lfo = A.ctx.createOscillator();
    lfo.frequency.value = 0.6;
    const lg = A.ctx.createGain();
    lg.gain.value = 0.008;
    lfo.connect(lg).connect(g.gain);
    o1.connect(g);
    o2.connect(g);
    n.connect(f).connect(ng).connect(g);
    g.gain.linearRampToValueAtTime(0.032, A.ctx.currentTime + 1.2);
    [o1, o2, n, lfo].forEach((x) => x.start());
    humNodes = { g, nodes: [o1, o2, n, lfo] };
  } catch (e) {}
}

export function startHum() {
  if (!enabled || humNodes) return;
  if (!ctx || ctx.state !== "running") {
    pendingHum = true;
    installGestureOnce();
    if (ctx) { try { ctx.resume(); } catch (e) {} }
    if (!ctx || ctx.state !== "running") return;
  }
  reallyStartHum();
}

export function stopHum() {
  pendingHum = false;
  if (!humNodes) return;
  try {
    const t = ctx.currentTime;
    humNodes.g.gain.linearRampToValueAtTime(0.0001, t + 0.4);
    const nodes = humNodes.nodes;
    setTimeout(() => {
      nodes.forEach((x) => {
        try { x.stop(); } catch (e) {}
      });
    }, 600);
  } catch (e) {}
  humNodes = null;
}